<template>
  <div>
    <GameList :gameType="categoryid"></GameList>
  </div>
</template>

<script>
import GameList from '../components/GameList.vue';
// import { getIP } from "../api/ipapi.js";

export default {
  name: "category-view",
  components: {
    GameList,
  },
  created() { },
  data() {
    return {
      categoryname: this.$route.params.categoryname,
      categoryid: parseInt(this.$route.params.categoryid),
    };
  },
  watch: {
    $route(to) {
      this.categoryname = to.params.categoryname;
      this.categoryid = parseInt(this.$route.params.categoryid);
      // this.$forceUpdate();
    },
  },
  mounted() {
    console.log('cate mounted');

    // Get the 'channel' query parameter from the URL
    let channel = this.$route.query.ch;
    console.log('cate mounted: ', channel);
    // this.getGameList();
    if (channel) {
      this.checkIP(channel);
    }
  },
  methods: {
    // checkIP(channel) {
    //   // getIP().then(res => {
    //   //   // Check if the response is valid and contains the status 'success'
    //   //   if (res.request.readyState === 4 && res.status === 200) {
    //   //     if (res.data.status === 'success') {
    //   //       // Check the country code for redirection conditions
    //   //       if (['SG', 'CN', 'HK', 'MO'].includes(res.data.countryCode)) {
    //   //         // If countryCode is SG, CN, MO, or HK, do nothing and exit
    //   //         return;
    //   //       }
    //   //     }
    //   //   }

    //   //   if (channel == 'b') {
    //   //     // Set the interval to refresh the page after 13 seconds if condition fails
    //   //     this.refreshInterval = setInterval(() => {
    //   //       location.href = `https://bytebulletin.com`;
    //   //     }, 5000);
    //   //   } else if (channel == 'w') {
    //   //     // Set the interval to refresh the page after 13 seconds if condition fails
    //   //     this.refreshInterval = setInterval(() => {
    //   //       location.href = `https://whirlblend.com`;
    //   //     }, 5000);
    //   //   } else if (channel == 'f') {
    //   //     // Set the interval to refresh the page after 13 seconds if condition fails
    //   //     this.refreshInterval = setInterval(() => {
    //   //       location.href = `https://fintechfountain.com`;
    //   //     }, 5000);
    //   //   }
    //   // }).catch(err => {
    //   //   console.error(err);
    //   // });
    // },
  }
};
</script>

<style lang="scss" scoped></style>